import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ConfigService } from '../../../../shared/services/config.service';
import { UserService } from '../../../../shared/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class SetupEmployeeService {

  //#976 BEA 2021-01-08 to force reading from localstorage each (and every) time
  private get httpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'APIKEY': 'ams-direct-api-basic-key',
        'SessionId': this.userService.sessionId
      })
    };
  }

  constructor(private http: HttpClient, private configService: ConfigService, private userService: UserService) {
    
   }
    

    getEmployees(companyId: number): Observable<any> {
        let userId = this.userService.account.EmployeeId;
        return this.http.get<any>(this.configService.config.basicUrl + `/api/employee/Get?companyId=${companyId}&userId=${userId}`, this.httpOptions);
    }

    updateEmployee(employee): Observable<any> {
      return this.http.put<any>(this.configService.config.basicUrl + '/api/employee/UpdateEmployee', employee, this.httpOptions);
    }

    checkUserExists(userId): Observable<any> {
      return this.http.get<any>(this.configService.config.basicUrl + `/api/employee/CheckUserExists?userId=${userId}`, this.httpOptions);
    }

    insertEmployee(employee): Observable<any> {
      return this.http.post<any>(this.configService.config.basicUrl + '/api/employee/AddEmployee', employee, this.httpOptions);
    }

    deleteEmployee(employeeId): Observable<any> {
      return this.http.delete<any>(this.configService.config.basicUrl + '/api/employee/DeleteEmployee?employeeId=' + employeeId, this.httpOptions);
    }
  
    saveEmployee(company: any, contact: any, admin: any): Observable<any> {
        var companyInfo = {
            Company: company,
            Contact: contact,
            Admin: admin
        }
        return this.http.post<any>(this.configService.config.basicUrl + '/api/company/SaveCompanyInfo', companyInfo, this.httpOptions);
    }

    getCalculationMethods(): Observable<any> {
        let companyId = this.userService.account.CompanyId;
        return this.http.get<any>(this.configService.config.basicUrl + `/api/employee/GetCalculationMethods?companyId=${companyId}`, this.httpOptions);
    }

    getSalaryGroups(): Observable<any> {
        let companyId = this.userService.account.CompanyId;
        return this.http.get<any>(this.configService.config.basicUrl + `/api/employee/GetSalaryGroups?companyId=${companyId}`, this.httpOptions);
    }

    getBalanceGroups(): Observable<any> {
        let companyId = this.userService.account.CompanyId;
        return this.http.get<any>(this.configService.config.basicUrl + `/api/employee/GetBalanceGroups?companyId=${companyId}`, this.httpOptions);
    }

    getLanguages():  Observable<any> {
      return this.http.get<any>(this.configService.config.basicUrl + `/api/employee/GetLanguages`, this.httpOptions);
    }

}
